import {CalendarRegularPenIcon} from 'shells/icon/svg/calendar-regular-pen-icon';
import {ChatBubbleDoubleRegularIcon} from 'shells/icon/svg/chat-bubble-double-regular-icon';
import {ChatRegularIcon} from 'shells/icon/svg/chat-regular-icon';
import {ChatbotIcon} from 'shells/icon/svg/chatbot-icon';
import {EnvelopeNewIcon} from 'shells/icon/svg/envelope-new-icon';
import {PhoneOutlineIcon} from 'shells/icon/svg/phone-outline-icon';
import {QuoteRegularIcon} from 'shells/icon/svg/quote-regular-icon';

import {CREATOR_ORIGIN_CATEGORY_DISPLAY_NAME_TO_KEY, CREATOR_ORIGIN_CATEGORY_LABELS} from './types';
import type {CreatorOriginCategory, CreatorOriginDisplayName} from './types';

export function getCreatorOriginCategoryFromDisplayName(
    displayName: string
): CreatorOriginCategory | undefined {
    if (displayName in CREATOR_ORIGIN_CATEGORY_DISPLAY_NAME_TO_KEY) {
        return CREATOR_ORIGIN_CATEGORY_DISPLAY_NAME_TO_KEY[displayName as CreatorOriginDisplayName];
    }

    return undefined;
}

export function getNameByCreatorOriginCategory(creatorOriginCategory: CreatorOriginCategory) {
    return CREATOR_ORIGIN_CATEGORY_LABELS[creatorOriginCategory] ?? creatorOriginCategory;
}

export function getIconByCreatorOriginCategory(creatorOriginCategory: CreatorOriginCategory) {
    switch (creatorOriginCategory) {
        case 'chat_thread':
        case 'chat_offline':
            return ChatBubbleDoubleRegularIcon;
        case 'engagement_booking':
            return CalendarRegularPenIcon;
        case 'engagement_text':
            return ChatRegularIcon;
        case 'engagement_call':
            return PhoneOutlineIcon;
        case 'engagement_quote':
            return QuoteRegularIcon;
        case 'engagement_email':
            return EnvelopeNewIcon;
        case 'chatbot':
            return ChatbotIcon;
        default:
            return null;
    }
}
